module.exports = __webpack_public_path__ + "static/media/photo254.002d4392.jpg";